import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useModuleVisibility } from '../modules/useModuleVisibility';

interface Props {
    /** A key of the sidebar / launcher visibility map (e.g. `fixedAssets`, `procurement.suppliers`). */
    visibilityKey: string;
}

/**
 * Route-level twin of a menu rule: when the menu entry is hidden for the user, typing the URL redirects home too.
 * Used where a role holds a VIEW key only for a picker (maintenance roles: SUPPLIER_VIEW, FIXED_ASSET_VIEW), so the
 * key stays valid for the API while the pages stay closed. Nest it inside the usual PermissionRoute.
 */
const MenuVisibilityRoute: React.FC<Props> = ({ visibilityKey }) => {
    const { permissionsReady } = useAuth();
    const { visibility } = useModuleVisibility();
    if (!permissionsReady) {
        return null;
    }
    return visibility[visibilityKey] ? <Outlet /> : <Navigate to="/" replace />;
};

export default MenuVisibilityRoute;
